module.exports = __webpack_public_path__ + "img/mynumber-frontup.b9df89a7.png";